export default __webpack_public_path__ + "static/media/icon-cloud.3ca04520.svg";